import { render, staticRenderFns } from "./CoffeeAcc.vue?vue&type=template&id=9481c0a0&scoped=true&"
import script from "./CoffeeAcc.vue?vue&type=script&lang=js&"
export * from "./CoffeeAcc.vue?vue&type=script&lang=js&"
import style0 from "./CoffeeAcc.vue?vue&type=style&index=0&id=9481c0a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9481c0a0",
  null
  
)

export default component.exports